/** 
 * 
*/
export const ACCESS_TYPES = {
    ACCESS_AREA: 1,
    FLOOR_AREA: 2,
    OSS_AREA: 3, // Does not exist. Will just mean we don't show any area.
    ACCESS_GROUP: 1,
    FLOOR_GROUP: 2,
    OSS_GROUP: 3,
}

export const getAccessGroupPath = (accessType: number | null) => {
    const defaultPath = '/access-control/enrolment/access-group/';

    if (accessType === null) {
        return defaultPath;
    }

    switch (accessType) {
        case ACCESS_TYPES.ACCESS_GROUP:
            return '/access-control/enrolment/access-group/';
        case ACCESS_TYPES.FLOOR_GROUP:
            return '/access-control/enrolment/floor-group/';
        case ACCESS_TYPES.OSS_GROUP:
            return '/access-control/enrolment/oss-group/';
        default:
            return defaultPath;
    }
}
